import React, {ReactElement} from "react";
import {styled, Typography} from "@mui/material";

const StyledTypography = styled(Typography)(({theme}) => ({
    textAlign: 'center',
    textWrap: 'pretty',
    backgroundColor: `${theme.palette.secondary.main}99`,
    borderRadius: 8, // todo
    padding: theme.spacing(2),
    maxWidth: 800,
    alignSelf: 'center',
    boxShadow: theme.shadows[1],
}));

interface IProps {
    text: string;
}

function DescriptionText({text}: IProps): ReactElement {
    return <StyledTypography variant={"h6"}>
        {text}
    </StyledTypography>
}

export default DescriptionText;
